export default __webpack_public_path__ + "a9f5e15b63a8ec994f6282d5c7e5f5b1.svg";